module.exports = __webpack_public_path__ + "img/typing_indicator.6db911eb.gif";